import {ProdRequest} from '../../interfaces/product-management/prod-request';
import {LightProduct} from '../../interfaces/product-management/light-product';
import {LightProductFactory} from './light-product-factory';
import {LightCustomer} from '../../interfaces/customers/light-customer';
import {LightCustomerFactory} from '../customers/light-customer-factory';
import {ProdRequestStatus} from '../../enums/product-management/prod-request-status.enum';
import {LightEmployee} from '../../interfaces/employees/light-employee';
import {LightEmployeeFactory} from '../employees/light-employee-factory';

export class ProdRequestFactory {

  /**
   *
   * @param prodRequest
   */
  public static fromObject(prodRequest: any): ProdRequest {
    return new class implements ProdRequest {
      customerId: number = prodRequest.customer_id;
      finished: string = prodRequest.finished;
      finishedType: 'internal' | 'external' = prodRequest.finished_type;
      comment: string = prodRequest.comment;
      ordered: string = prodRequest.ordered;
      pickedUp: string = prodRequest.picked_up;
      pickedUpEmployeeId: number = prodRequest.picked_up_employee_id;
      prepared: string = prodRequest.prepared;
      productId: number = prodRequest.product_id;
      requestedEmployeeId: number = prodRequest.requested_employee_id;
      serviceFacilityId: number = prodRequest.service_facility_id;
      status: ProdRequestStatus = prodRequest.status;
      userId: number = prodRequest.user_id;
      product: LightProduct = LightProductFactory.fromObject(prodRequest.product);
      amount: number = prodRequest.amount;
      requestedEmployee: LightEmployee = LightEmployeeFactory.fromObject(prodRequest.requested_employee);
      pickedUpEmployee: LightEmployee =
        prodRequest.picked_up_employee ? LightEmployeeFactory.fromObject(prodRequest.picked_up_employee) : null;
      customer: LightCustomer = prodRequest.customer ? LightCustomerFactory.fromObject(prodRequest.customer) : null;

      // ------------------------------------------------------------------------------------------------
      id: number = prodRequest.id;
      uuid: string = prodRequest.uuid;
      modified: string = prodRequest.modified;
      created: string = prodRequest.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param pmRequests
   */
  public static fromArray(pmRequests: ProdRequest[]): ProdRequest[] {
    return pmRequests.map(_pmRequest => this.fromObject(_pmRequest));
  }

  /**
   *
   * @param pmRequest
   */
  public static toRemote(pmRequest: ProdRequest): any {
    return {
      id: pmRequest.id,
      requested_employee_id: pmRequest.requestedEmployeeId,
      customer_id: pmRequest.customerId,
      service_facility_id: pmRequest.serviceFacilityId,
      product_id: pmRequest.productId,
      amount: pmRequest.amount,
      comment: pmRequest.comment
    };
  }

  /**
   *
   * @param pmRequest
   */
  public static new(pmRequest: Partial<ProdRequest> = {}): ProdRequest {
    const newPmRequest: ProdRequest = new class implements ProdRequest {
      amount: number = 1;
      comment: string = null;
      created: string = null
      customer: LightCustomer = null;
      customerId: number = null;
      finished: string = null;
      finishedType: "internal" | "external" = null;
      id: number = null;
      modified: string = null;
      ordered: string = null;
      pickedUp: string = null;
      pickedUpEmployeeId: number = null;
      prepared: string = null;
      product: LightProduct = null;
      productId: number = null;
      requestedEmployee: LightEmployee = null;
      requestedEmployeeId: number = null;
      serviceFacilityId: number = null;
      status: ProdRequestStatus = ProdRequestStatus.Requested;
      userId: number = null;
      uuid: string = null;
      pickedUpEmployee: LightEmployee = null;
    };

    return {...newPmRequest, ...pmRequest};
  }

}